import { useMutation, setConsole, MutateConfig } from "react-query";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { onError } from "src/Helpers";

export const mutator = async (config: AxiosRequestConfig) => {
  const { url, method, data, headers } = config;
  const userString = localStorage.getItem("user");
  const user = JSON.parse(userString ?? '{}');
  const idToken = localStorage.getItem(user.keyPrefix + '.' + user.username + '.idToken');
  return await axios.request({
    url,
    method: method ?? "POST",
    data,
    ...config,
    headers: {
      ...config?.headers,
      ...headers,
      'X-COG-ID': idToken,
    },
  });
};

setConsole({
  log: console.log,
  warn: console.warn,
  error: console.warn,
});

function useApiMutation(
  mutationConfig?: MutateConfig<AxiosResponse<any>, unknown> | undefined
) {
  return useMutation(mutator, { onError, ...mutationConfig });
}

export default useApiMutation;

// Usage

// const [mutate, {status, data, error}] = useApiMutation();

// console.log(data);
// console.log(status);
// console.log(error);

// useEffect(() => {
//   mutate({
//     url: '/users',
//     data: {
//       name: 'morpheus',
//       job: 'leader',
//     },
//     method: 'POST',
//   });
// }, [mutate]);
